import { forwardRef, ReactNode, useMemo } from 'react';
import { Calendar } from 'data/firestore/agent/calendar/types';
import getHolidaysForDate from './getHolidaysForDate';
import {
    Container,
    Hours,
    HeaderItems,
    HeaderItem,
    Label,
    HeaderContent,
    AllDayItems,
    HolidayChip,
} from './styled';

export interface CalendarViewColumnHeader {
    id: string;
    label: ReactNode;
}

interface HeaderProps {
    calendars: Calendar[];
    columns?: CalendarViewColumnHeader[];
    date?: Date;
    timeZone?: string;
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(
    (props, ref) => {
        const {
            calendars,
            columns,
            date = new Date(),
            timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
        } = props;
        const calendarsList = useMemo(
            () => (columns || calendars.map((calendar) => ({
                id: calendar.id,
                label: (
                    <HeaderContent>
                        <Label>{calendar.name}</Label>
                        <AllDayItems>
                            {getHolidaysForDate([calendar], date, timeZone)
                                .map((holiday) => (
                                    <HolidayChip
                                        key={holiday.id}
                                        $color={calendar.color}
                                        title={holiday.name}
                                    >
                                        {holiday.name}
                                    </HolidayChip>
                                ))}
                        </AllDayItems>
                    </HeaderContent>
                ),
            }))).map((column) => (
                <HeaderItem key={column.id}>
                    {column.label}
                </HeaderItem>
            )),
            [calendars, columns, date, timeZone],
        );

        return (
            <Container role="presentation">
                <Hours />
                <HeaderItems ref={ref}>
                    <div />
                    {calendarsList}
                </HeaderItems>
                <div />
            </Container>
        );
    },
);

export default Header;
